import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "@phosphor-icons/react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-background">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="rounded-[2.5rem] bg-white shadow-soft-lg border border-white p-10 max-w-md w-full text-center"
      >
        <XCircle weight="duotone" className="mx-auto text-foreground/40" size={64} />
        <h1 className="font-display font-bold text-2xl mt-5 text-foreground">{t("cancel.title")}</h1>
        <p className="text-foreground/55 font-medium mt-2">{t("cancel.desc")}</p>
        <button
          data-testid="cancel-retry"
          onClick={() => navigate("/")}
          className="mt-6 rounded-full bg-primary px-7 py-3.5 font-bold text-primary-foreground shadow-soft"
        >
          {t("cancel.retry")}
        </button>
      </motion.div>
    </div>
  );
}
